// shared/snippets.ts
// Snippets: reusable pieces of a make_video spec (an end card, a style, a
// music setting, or a run of beats) that the editor inserts into a project.
// Shared by api/src/snippets.ts (validation, the source of truth) and the
// editor. A fragment is a partial spec holding exactly one top-level key,
// the one its kind names; inserting deep-merges it, except beats, which are
// inserted as new beats.
// ─────────────────────────────────────────────────────────────────
export const SNIPPET_KINDS = ['endCard', 'style', 'audio', 'beats'];
export function isSnippetKind(v) {
    return typeof v === 'string' && SNIPPET_KINDS.includes(v);
}
/** What each kind is called in the editor. */
export const SNIPPET_KIND_LABELS = {
    endCard: 'End card',
    style: 'Text style',
    audio: 'Music',
    beats: 'Beats',
};
export const MAX_SNIPPET_NAME = 100;
/** Per account, so the editor's menu (and the list call) stays small. */
export const MAX_SNIPPETS = 200;
